import { v4 as uuidv4 } from 'uuid';

/**
 * Custom specs are free-form label/value rows a designer adds to an item for
 * the details that don't fit Color / Finish / Material / Dimensions — COM
 * yardage, cushion counts, a specific leg finish, and so on.
 *
 * Shape: [{ id, label, value }]
 */

export function newCustomSpec() {
  return { id: uuidv4(), label: '', value: '' };
}

/** Rows worth rendering or saving — a label is required, a value isn't. */
export function visibleCustomSpecs(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((row) => row && typeof row === 'object')
    .map((row, i) => ({
      id: String(row.id || `spec-${i}`),
      label: String(row.label ?? '').trim(),
      value: String(row.value ?? '').trim(),
    }))
    .filter((row) => row.label);
}

/** Single-line rendering for the places that show specs as one run of text. */
export function formatCustomSpecs(raw) {
  return visibleCustomSpecs(raw)
    .map((row) => (row.value ? `${row.label}: ${row.value}` : row.label))
    .join(' · ');
}
